import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import {
    createInteractionList,
    InteractionList,
} from '@vfde-brix/ws10/interaction-list';
import { AppQuery } from '../enum';
import { Actions } from '../container/App';
import { getQueryParam } from '@vfde-sails/utils';

/**
 * Creates a WS10 Interaction List component.
 */
export const mountInteractionList = (id: string) =>
    createComponentById(createInteractionList, id, NO_PATTERN_BUSINESS_LOGIC);

/**
 * Adds onClick events for the pathfinder items based on the pathfinder query
 */
export const setPathfinderRoutingBusiness = (list: InteractionList, { stepToNextLevel }: Actions, wrapperId: string) => {
    const props = list.getProperties();

    for (const [index, listItem] of props.listItems.entries()) {
        const linkedLevelId = getQueryParam(AppQuery.Pathfinder, listItem.linkHref);

        if (!linkedLevelId) {
            continue;
        }

        const itemEl = document.getElementById(wrapperId)?.getElementsByTagName('a')[index];

        itemEl?.addEventListener('click', (event: Event) => {
            event.preventDefault();
            stepToNextLevel(linkedLevelId);
        });
    }
};
